'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseAlerts = require('@bibliocommons/base-alerts');

require('@bibliocommons/assets/stylesheets/animations.scss');

var _toolbarListInfo = require('../../toolbar-list-info');

var _toolbarListInfo2 = _interopRequireDefault(_toolbarListInfo);

var _backButton = require('../../back-button');

var _backButton2 = _interopRequireDefault(_backButton);

var _settingsButton = require('../../settings-button');

var _settingsButton2 = _interopRequireDefault(_settingsButton);

var _addItemsButton = require('../../add-items-button');

var _addItemsButton2 = _interopRequireDefault(_addItemsButton);

var _publishButton = require('../../publish-button');

var _publishButton2 = _interopRequireDefault(_publishButton);

var _saveDraftButton = require('../../save-draft-button');

var _saveDraftButton2 = _interopRequireDefault(_saveDraftButton);

var _previewButton = require('../../preview-button');

var _previewButton2 = _interopRequireDefault(_previewButton);

var _settings = require('../../settings');

var _settings2 = _interopRequireDefault(_settings);

require('../styles/Toolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toolbar = function (_BcReactComponent) {
  _inherits(Toolbar, _BcReactComponent);

  function Toolbar(props) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));

    _this.bindAll('handleSaveAsDraft', 'handlePublish', 'handleToggleSettingsMenu', 'handleSettingsButtonClick', 'renderContents', 'renderAddItemsButton', 'renderPreviewButton', 'updateInitialOffset', 'renderSettings', 'renderMessages');
    _this.handleScroll = _lodash2.default.throttle(_this.handleScroll, 50).bind(_this);
    _this.handleResize = _lodash2.default.throttle(_this.updateInitialOffset, 50).bind(_this);

    _this.state = {
      stickToTop: false,
      initialOffset: 0,
      stickyOffset: 0,
      showSettings: false
    };
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
      this.updateInitialOffset();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'handleSaveAsDraft',
    value: function handleSaveAsDraft() {
      this.props.handleFormSubmit({ isPrivate: true });
    }
  }, {
    key: 'handlePublish',
    value: function handlePublish() {
      this.props.handleFormSubmit({ isPrivate: false });
    }
  }, {
    key: 'renderPreviewButton',
    value: function renderPreviewButton() {
      if (this.props.list.isPrivate || !this.props.list.id) {
        return _react2.default.createElement(_saveDraftButton2.default, {
          list: this.props.list,
          items: this.props.items,
          listHasUnsavedChanges: this.props.listHasUnsavedChanges,
          savingDraft: this.props.savingDraft,
          publishing: this.props.publishing,
          editingAnchorBib: this.props.editingAnchorBib,
          handleClick: this.handleSaveAsDraft });
      }

      return _react2.default.createElement(_previewButton2.default, { previewURL: this.props.listPreviewURL });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      // See http://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var changes = {};

      changes.stickyOffset = this.props.getOffsetForStickyToolbar();

      var shouldStickToTop = scrollTop > this.state.initialOffset - changes.stickyOffset;
      if (this.state.stickToTop !== shouldStickToTop) {
        changes.stickToTop = shouldStickToTop;
      }

      this.setState(changes);
    }
  }, {
    key: 'handleToggleSettingsMenu',
    value: function handleToggleSettingsMenu() {
      this.setState({ showSettings: !this.state.showSettings });
    }
  }, {
    key: 'handleSettingsButtonClick',
    value: function handleSettingsButtonClick() {
      this.setState({
        showSettings: !this.state.showSettings
      });
    }
  }, {
    key: 'updateInitialOffset',
    value: function updateInitialOffset() {
      var top = this.toolbarDiv.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop;
      this.setState({
        initialOffset: top
      });
    }
  }, {
    key: 'renderSettings',
    value: function renderSettings() {
      if (this.state.showSettings) {
        var _props = this.props,
            items = _props.items,
            list = _props.list,
            listScopes = _props.listScopes,
            listLanguages = _props.listLanguages,
            listLocales = _props.listLocales,
            selectableListTypes = _props.selectableListTypes,
            handleListPropertyChange = _props.handleListPropertyChange;


        return _react2.default.createElement(
          'div',
          { className: 'boxed-row row' },
          _react2.default.createElement(_settings2.default, {
            list: list,
            items: items,
            handleListPropertyChange: handleListPropertyChange,
            handleToggleSettingsMenu: this.handleToggleSettingsMenu,
            listScopes: listScopes,
            listLanguages: listLanguages,
            listLocales: listLocales,
            selectableListTypes: selectableListTypes,
            listHasUnsavedChanges: this.props.listHasUnsavedChanges })
        );
      }

      return null;
    }
  }, {
    key: 'renderAddItemsButton',
    value: function renderAddItemsButton() {
      if (this.props.editingAnchorBib) {
        return null;
      }

      return _react2.default.createElement(_addItemsButton2.default, { handleClick: this.props.handleOpenAddToList });
    }
  }, {
    key: 'renderMessages',
    value: function renderMessages() {
      return this.props.messages.map(function (message, index) {
        if (message.type === 'error') {
          return _react2.default.createElement(
            _baseAlerts.AlertFailure,
            { key: index + '-' + message.key },
            message.key
          );
        }

        return _react2.default.createElement(
          _baseAlerts.AlertSuccess,
          { key: index + '-' + message.key },
          message.key
        );
      });
    }
  }, {
    key: 'renderContents',
    value: function renderContents(extraClasses) {
      var _props2 = this.props,
          handleBackButtonClick = _props2.handleBackButtonClick,
          list = _props2.list;


      return _react2.default.createElement(
        'div',
        { className: 'toolbar-container ' + extraClasses + ' row', style: { top: this.state.stickyOffset + 'px' } },
        _react2.default.createElement(
          'div',
          { className: 'boxed-row row' },
          _react2.default.createElement(
            'div',
            { className: 'summary col-xs-12 col-sm-7' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_backButton2.default, { handleClick: handleBackButtonClick }),
              _react2.default.createElement(_toolbarListInfo2.default, { list: list, handleSaveAsDraft: this.handleSaveAsDraft, savingDraft: this.props.savingDraft })
            ),
            this.renderAddItemsButton()
          ),
          _react2.default.createElement(
            'div',
            { className: 'actions col-xs-12 col-sm-5' },
            _react2.default.createElement(
              'span',
              null,
              this.renderPreviewButton(),
              _react2.default.createElement(_publishButton2.default, {
                list: this.props.list,
                items: this.props.items,
                listHasUnsavedChanges: this.props.listHasUnsavedChanges,
                savingDraft: this.props.savingDraft,
                publishing: this.props.publishing,
                editingAnchorBib: this.props.editingAnchorBib,
                handleClick: this.handlePublish })
            ),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_settingsButton2.default, { handleClick: this.handleSettingsButtonClick })
            )
          )
        ),
        this.renderSettings(),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'fade', transitionEnterTimeout: 500, transitionLeaveTimeout: 500 },
          this.renderMessages()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var editingAnchorBib = this.props.editingAnchorBib;

      var stickToTop = this.state.stickToTop && !editingAnchorBib;

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-toolbar', ref: function ref(toolbarDiv) {
            _this2.toolbarDiv = toolbarDiv;
          } },
        this.renderContents(),
        stickToTop ? this.renderContents('sticky') : false
      );
    }
  }]);

  return Toolbar;
}(_baseBcReactComponent2.default);

Toolbar.propTypes = {
  list: _bcPropTypes.listShape,
  items: _react.PropTypes.arrayOf(_bcPropTypes.listItemShape),
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  handleFormSubmit: _react.PropTypes.func.isRequired,
  handleBackButtonClick: _react.PropTypes.func.isRequired,
  handleOpenAddToList: _react.PropTypes.func.isRequired,
  listScopes: _react.PropTypes.objectOf(_react.PropTypes.string).isRequired,
  listLocales: _react.PropTypes.objectOf(_react.PropTypes.string).isRequired,
  selectableListTypes: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  listHasUnsavedChanges: _react.PropTypes.bool.isRequired,
  savingDraft: _react.PropTypes.bool.isRequired,
  publishing: _react.PropTypes.bool.isRequired,
  editingAnchorBib: _react.PropTypes.bool.isRequired,
  listPreviewURL: _react.PropTypes.string,
  messages: _react.PropTypes.arrayOf(_react.PropTypes.shape({ type: _react.PropTypes.string, key: _react.PropTypes.string }))
};

exports.default = Toolbar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/toolbar/components/Toolbar.component.js
// module id = 1346
// module chunks = 0